export enum SloopEnum {
  SLOOP = 'Sloop',
}
